import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { ErrorBoundary } from './components/ErrorBoundary';
import { SEO } from './components/SEO';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { AIEngineVisualization } from './components/AIEngineVisualization';
import { HowItWorks } from './components/HowItWorks';
import { ForHospitals } from './components/ForHospitals';
import { ForSuppliers } from './components/ForSuppliers';
import { Footer } from './components/Footer';

/**
 * Main App component with error boundary and SEO
 */
function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <SEO />
        <div className="min-h-screen bg-white">
          <Header />
          <main>
            <Hero />
            <AIEngineVisualization />
            <HowItWorks />
            <ForHospitals />
            <ForSuppliers />
          </main>
          <Footer />
        </div>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App; 